import React, { useEffect, useRef } from 'react'
import { AiOutlineDelete } from 'react-icons/ai'
import { MdDelete } from 'react-icons/md'
import { RiErrorWarningFill } from 'react-icons/ri';

const RecipeCreateForm = ({ formikRecipe, formikIngredient, handleChangeImage, imageURL, setImageURL, ingredients, removeIngredient}) => {

    const uploadRef = useRef();

    const handleFocus = () => {
        const image = document.getElementById('input-image');
        image.click();
    }

    useEffect(() => {
        const handler = (e) => {
            if (uploadRef.current && uploadRef.current.contains(e.target)) {
                document.addEventListener('focus', handleFocus())
            }
        }

        document.addEventListener('mousedown', handler)
        return () => {
            document.removeEventListener('mousedown', handler)
        }
    })

    return (
        <div className='create-recipe section'>
            <div className='create-container'>
                <div className='create-container-title'>
                    <h2>🧑🏻‍🍳 Share your recipe 🍔</h2>
                </div>
                <div className='create-container-form'>
                    <form encType='multipart/form-data'>
                        <ul>
                            <li className='form-line'>
                                <label className='form-label'>Recipe Name: </label>
                                <div className='form-input'>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formikRecipe.values.name}
                                        onChange={formikRecipe.handleChange}
                                        placeholder='Enter recipe name' />
                                    {formikRecipe.errors.name && <p className='warning'><RiErrorWarningFill /></p>}
                                </div>
                            </li>
                            <li className='form-line'>
                                <label className='form-label'>Description: </label>
                                <div className='form-input'>
                                    <textarea
                                        className='form-textarea'
                                        placeholder='Enter description'
                                        name="description"
                                        value={formikRecipe.values.description}
                                        onChange={formikRecipe.handleChange}
                                    >
                                    </textarea>
                                    {formikRecipe.errors.description && <p className='warning textarea'><RiErrorWarningFill /></p>}
                                </div>
                            </li>
                            <li className='form-line'>
                                <label className='form-label'>Ingredients:</label>
                                <div className='form-input'>
                                    <table className='ingredient-table'>
                                        <thead>
                                            <tr id='ingredient-table-header'>
                                                <th>Name</th>
                                                <th>Amount</th>
                                                <th>Calculation Unit</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ingredients?.map((ingredient, index) => (
                                                <tr key={index}>
                                                    <td>{ingredient.name}</td>
                                                    <td>{ingredient.amount}</td>
                                                    <td>{ingredient.unit}</td>
                                                    <td>
                                                        <MdDelete id='btn-ingredient-remove'
                                                            onClick={() => removeIngredient(ingredient.name)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}

                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td>
                                                    Total: {ingredients.length}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input
                                                        type="text" name="name"
                                                        value={formikIngredient.values.name}
                                                        onChange={formikIngredient.handleChange}
                                                        placeholder='Ex: sugar...'
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text" name="amount"
                                                        value={formikIngredient.values.amount}
                                                        onChange={formikIngredient.handleChange}
                                                        placeholder='Ex: 200'
                                                    />
                                                </td>
                                                <td>
                                                    <input type="text" name="unit"
                                                        value={formikIngredient.values.unit}
                                                        onChange={formikIngredient.handleChange}
                                                        placeholder='Ex: gram'
                                                    />
                                                </td>
                                                <td>
                                                    <button type='submit' onClick={formikIngredient.handleSubmit}
                                                    >
                                                        add
                                                    </button>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </li>
                            <li className='form-line'>
                                <label className='form-label processing'>Steps:</label>
                                <div className='form-input'>
                                    <div className='step-container'>
                                        <textarea
                                            placeholder='Enter step 1...'
                                            name="processingSteps"
                                            value={formikRecipe.values.processingSteps}
                                            onChange={formikRecipe.handleChange}
                                        ></textarea>
                                        {formikRecipe.errors.processingSteps && <p className='warning textarea'><RiErrorWarningFill /></p>}
                                    </div>
                                </div>
                            </li>
                            <li className='form-line'>
                                <label className='form-label'>Note: </label>
                                <div className='form-input'>
                                    <textarea
                                        placeholder='Enter Note'
                                        name="note"
                                        value={formikRecipe.values.note}
                                        onChange={formikRecipe.handleChange}
                                    ></textarea>
                                    {formikRecipe.errors.note && <p className='warning textarea'><RiErrorWarningFill /></p>}
                                </div>
                            </li>
                            <li className='form-line'>
                                <label className='form-label'>Point: </label>
                                <div className='form-input'>
                                    <input
                                        type="text"
                                        placeholder='Ex: 100'
                                        name="point"
                                        value={formikRecipe.values.point}
                                        onChange={formikRecipe.handleChange}
                                    />
                                    {formikRecipe.errors.point && <p className='warning'><RiErrorWarningFill /></p>}
                                </div>
                            </li>
                            <li className='form-line'>
                                <label className='form-label image' htmlFor='input-image'>Image: </label>
                                <div className='form-input upload-image-container'>
                                    <div
                                        className='upload-image'
                                        title='Upload your image'
                                        ref={uploadRef}
                                    >
                                        Browse Files
                                        <div>Drag and drop files here</div>
                                    </div>
                                    <div className='input-image-container'>
                                        <input type="file"
                                            id='input-image'
                                            name='file'
                                            // multiple="multiple"
                                            onChange={handleChangeImage}
                                        />
                                    </div>
                                    <ul className='upload-list'>
                                        {imageURL && (<li className='image-container'>
                                            <div className='image-container-item'>
                                                <img src={imageURL} alt='' />
                                            </div>
                                            <span>Recipe Image</span>
                                            <span
                                                className='delete-icon'
                                                onClick={() => setImageURL(null)}
                                            >
                                                <AiOutlineDelete />
                                            </span>
                                        </li>
                                        )}
                                    </ul>
                                </div>
                            </li>
                        </ul>
                        <div className='submit-button'>
                            <button type='button' onClick={formikRecipe.handleSubmit}>Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default RecipeCreateForm